"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.PopoverContent = exports.Content = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _stylers = _interopRequireDefault(require("@paprika/stylers"));

var _popover = _interopRequireDefault(require("@paprika/popover"));

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Content = _styledComponents["default"].div.withConfig({
  displayName: "Contentstyles__Content",
  componentId: "sc-1vgomek-0"
})(["&:focus{", "}"], _stylers["default"].focusRing.subtle(true));

exports.Content = Content;
var PopoverContent = (0, _styledComponents["default"])(_popover["default"].Content).withConfig({
  displayName: "Contentstyles__PopoverContent",
  componentId: "sc-1vgomek-1"
})(function (_ref) {
  var contentOffsetX = _ref.contentOffsetX,
      contentOffsetY = _ref.contentOffsetY;
  return (0, _styledComponents.css)(["margin:", "px ", "px;"], contentOffsetY, contentOffsetX);
});
exports.PopoverContent = PopoverContent;
//# sourceMappingURL=Content.styles.js.map